///////////////////////////////////
//////////Running Code:::::

// import React, { useEffect, useState, memo, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Outlet } from 'react-router-dom';
// import toast from 'react-hot-toast';
// import { useSelector } from 'react-redux';

// import { tokenVerify } from '../../API/API';
// import Reloading from '../../utilities/Reloading/Reloading';
// import classes from './Dashboard.module.scss';
// import Header from './components/Header/Header';

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const state = useSelector(state => state.login);

//   const data = JSON.parse(localStorage.getItem('data'));
//   const localUserId = localStorage.getItem('userID');

//   const LOGGED_OUT = useRef(null);
//   const TOKEN_BAD = useRef(null);
//   const VERIFIER = useRef(null);
//   const APP_ISSUE = useRef(null);
//   const WEAK_SIGNAL_OR_NO_NETWORK = useRef(null);

//   useEffect(() => {

//     if (window.env) {
//       LOGGED_OUT.current = window.env.ERROR.LOGGED_OUT
//       TOKEN_BAD.current = window.env.ERROR.TOKEN_BAD
//       APP_ISSUE.current = window.env.ERROR.APP_ISSUE
//       VERIFIER.current = window.env.VERIFIER
//       WEAK_SIGNAL_OR_NO_NETWORK.current = window.env.ERROR.WEAK_SIGNAL_OR_NO_NETWORK;
//     } else {
//       toast.error("Problem in getting ENV File");
      
//     }

//     if (JSON.parse(localStorage.getItem('data'))=== null || localStorage.getItem('userID') === null) {
//       localStorage.clear()
//       navigate('/');
//       toast(LOGGED_OUT.current, {
//         icon: '❗',
//       });
//       return;
//     }

   
//     //To check token and logout

//     const checkToken = setInterval(() => {
//       if (localStorage.getItem('data') === null || localStorage.getItem('userID') === null) {
//         localStorage.clear()
//         navigate('/');
//         toast(APP_ISSUE.current, {
//           icon: '❗',
//         });
//         return;
//       }
//       if (localUserId !== null && data !== null) {

//         tokenVerify(localUserId, data.empid, data.token)
//           .then((response) => {

//             if (response.data.error === 'BADTOKEN') {
//               localStorage.clear()
//               navigate('/');
//               toast(TOKEN_BAD.current, {
//                 icon: '❗',
//               });
//             }
//             //To check for new Version Updates
//             let version = JSON.parse(localStorage.getItem("version"));
//             if(!version || version != response.data.version) {
//               toast("New Version Available! Refreshing!", {icon: '❗',}); 
//               localStorage.setItem("version", response.data.version);
//               setTimeout(() => {
//                 // localStorage.removeItem('data'); 
//                 // localStorage.setItem("version", response.data.version);
//                 window.location.reload(true);
//               },3000);
//             }
//           })
//           .catch((error) => {
//             // Handle error
//             // This was causing too many Pop-Ups when the window was left in the background as such removed this toast.
//             // toast(WEAK_SIGNAL_OR_NO_NETWORK.current, {
//             //   icon: '❗',
//             // });
//           });
//       }
//     }, VERIFIER.current);


//     return (() => {
//       clearInterval(checkToken)
//     })
//   }, [data])



//   return (
//     <div className={classes.Dashboard}>
//       {/* <Reloading /> */}
//       {/* Shows Header */}
//       <Header />
//       {/* Shows Checked In Time and Location */}
//       <Outlet />
//     </div>
//   )
// }

// export default Dashboard;


////////////////////////////////////////////////////////////////
///////////////Testing Code:::::::::::
//////////////////////////////////////////////////


import React, { useEffect, useState, memo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

import { tokenVerify } from '../../API/API';
import Reloading from '../../utilities/Reloading/Reloading';
import classes from './Dashboard.module.scss';
import Header from './components/Header/Header';

const Dashboard = () => {
  const navigate = useNavigate();
  const state = useSelector(state => state.login);

  const data = JSON.parse(localStorage.getItem('data'));
  const localUserId = localStorage.getItem('userID');

  const LOGGED_OUT = useRef(null);
  const TOKEN_BAD = useRef(null);
  const VERIFIER = useRef(null);
  const APP_ISSUE = useRef(null);
  const WEAK_SIGNAL_OR_NO_NETWORK = useRef(null);

  useEffect(() => {

    if (window.env) {
      LOGGED_OUT.current = window.env.ERROR.LOGGED_OUT
      TOKEN_BAD.current = window.env.ERROR.TOKEN_BAD
      APP_ISSUE.current = window.env.ERROR.APP_ISSUE
      VERIFIER.current = window.env.VERIFIER
      WEAK_SIGNAL_OR_NO_NETWORK.current = window.env.ERROR.WEAK_SIGNAL_OR_NO_NETWORK;
    } else {
      toast.error("Problem in getting ENV File");
    }

    if (JSON.parse(localStorage.getItem('data')) === null || localStorage.getItem('userID') === null) {
      localStorage.clear();
      navigate('/');
      toast(LOGGED_OUT.current, {
        icon: '❗',
      });
      return;
    }

    // Remove 'fetchedLoc' from localStorage           
    localStorage.removeItem('fetchedLoc');

    // To check token and logout
    const checkToken = setInterval(() => {
      if (localStorage.getItem('data') === null || localStorage.getItem('userID') === null) {
        localStorage.clear();
        navigate('/');
        toast(APP_ISSUE.current, {
          icon: '❗',
        });
        return;
      }
      if (localUserId !== null && data !== null) {

        tokenVerify(localUserId, data.empid, data.token)
          .then((response) => {

            if (response.data.error === 'BADTOKEN') {
              localStorage.clear();
              navigate('/');
              toast(TOKEN_BAD.current, {
                icon: '❗',
              });
            }
            // To check for new Version Updates
            let version = JSON.parse(localStorage.getItem("version"));
            if (!version || version !== response.data.version) {
              //toast("New Version Available! Refreshing!", { icon: '❗' });
              localStorage.setItem("version", response.data.version);
              setTimeout(() => {
                window.location.reload(true);
              }, 300000);         //Auto_referesh after 5 minutes.
            }
          })
          .catch((error) => {
            // Handle error
            // Handle error
             // This was causing too many Pop-Ups when the window was left in the background as such removed this toast.
            // toast(WEAK_SIGNAL_OR_NO_NETWORK.current, {
            //   icon: '❗',
          });
      }
    }, VERIFIER.current);

    return () => {
      clearInterval(checkToken);
    };
  }, [data]);

  return (
    <div className={classes.Dashboard}>
      {/* <Reloading /> */}
      {/* Shows Header */}
      <Header />
      {/* Shows Checked In Time and Location */}
      <Outlet />
    </div>
  );
}

export default Dashboard;





//////////////////////////////////////////////////////////////////////////////////////////
// import React, { useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Outlet } from 'react-router-dom';
// import toast from 'react-hot-toast';
// import { useSelector } from 'react-redux';

// import { tokenVerify } from '../../API/API';
// import classes from './Dashboard.module.scss';
// import Header from './components/Header/Header';

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const state = useSelector((state) => state.login);

//   const data = JSON.parse(localStorage.getItem('data'));
//   const localUserId = localStorage.getItem('userID');

//   const LOGGED_OUT = useRef(null);
//   const TOKEN_BAD = useRef(null);
//   const VERIFIER = useRef(null);
//   const APP_ISSUE = useRef(null);
//   const WEAK_SIGNAL_OR_NO_NETWORK = useRef(null);

//   useEffect(() => {
//     if (window.env) {
//       LOGGED_OUT.current = window.env.ERROR.LOGGED_OUT;
//       TOKEN_BAD.current = window.env.ERROR.TOKEN_BAD;
//       APP_ISSUE.current = window.env.ERROR.APP_ISSUE;
//       VERIFIER.current = window.env.VERIFIER;
//       WEAK_SIGNAL_OR_NO_NETWORK.current = window.env.ERROR.WEAK_SIGNAL_OR_NO_NETWORK;
//     } else {
//       toast.error('Problem in getting ENV File');
//     }

//     if (JSON.parse(localStorage.getItem('data')) === null || localStorage.getItem('userID') === null) {
//       localStorage.clear();
//       navigate('/');
//       toast(LOGGED_OUT.current, {
//         icon: '❗',
//       });
//       return;
//     }

//     // Remove 'fetchedLoc' from localStorage           
//     localStorage.removeItem('fetchedLoc');

//     // To check token and logout
//     const checkToken = setInterval(() => {
//       if (localStorage.getItem('data') === null || localStorage.getItem('userID') === null) {
//         localStorage.clear();
//         navigate('/');
//         toast(APP_ISSUE.current, {
//           icon: '❗',
//         });
//         return;
//       }
//       if (localUserId !== null && data !== null) {
//         tokenVerify(localUserId, data.empid, data.token)
//           .then((response) => {
//             if (response.data.error === 'BADTOKEN') {
//               localStorage.clear();
//               navigate('/');
//               toast(TOKEN_BAD.current, {
//                 icon: '❗',
//               });
//             }
//             // To check for new Version Updates
//             const version = JSON.parse(localStorage.getItem('version'));
//             if (!version || version !== response.data.version) {
//               localStorage.setItem('version', response.data.version);
//               setTimeout(() => {
//                 // window.location.reload(true);
//               }, 3000);
//             }
//           })
//           .catch(() => {
//             // Handle network or other errors gracefully
//           });
//       }
//     }, VERIFIER.current);

//     // Check location permission and clear fetched location if disabled
//     const checkLocationPermission = () => {
//       navigator.geolocation.getCurrentPosition(
//         () => {
//           // Location access enabled; no action needed
//         },
//         (error) => {
//           if (error.code === error.PERMISSION_DENIED) {
//             // Location access disabled; clear the previous location
//             localStorage.removeItem('fetchedLoc');
//             toast.error('Device location is off. Previous location removed.', {
//               icon: '⚠️',
//             });
//           }
//         }
//       );
//     };

//     checkLocationPermission();

//     return () => {
//       clearInterval(checkToken);
//     };
//   }, [data, localUserId, navigate]);

//   return (
//     <div className={classes.Dashboard}>
//       {/* Shows Header */}
//       <Header />
//       {/* Shows Checked In Time and Location */}
//       <Outlet />
//     </div>
//   );
// };

// export default Dashboard;








































